'use strict';

require('../vendor');

require('core-js/modules/es6.typed.array-buffer');

require('core-js/modules/es6.typed.int8-array');

require('core-js/modules/es6.typed.uint8-array');

require('core-js/modules/es6.typed.uint8-clamped-array');

require('core-js/modules/es6.typed.int16-array');

require('core-js/modules/es6.typed.uint16-array');

require('core-js/modules/es6.typed.int32-array');

require('core-js/modules/es6.typed.uint32-array');

require('core-js/modules/es6.typed.float32-array');

require('core-js/modules/es6.typed.float64-array');

require('core-js/modules/es6.map');

require('core-js/modules/es6.set');

require('core-js/modules/es6.weak-map');

require('core-js/modules/es6.weak-set');

require('core-js/modules/es6.reflect.apply');

require('core-js/modules/es6.reflect.construct');

require('core-js/modules/es6.reflect.define-property');

require('core-js/modules/es6.reflect.delete-property');

require('core-js/modules/es6.reflect.get');

require('core-js/modules/es6.reflect.get-own-property-descriptor');

require('core-js/modules/es6.reflect.get-prototype-of');

require('core-js/modules/es6.reflect.has');

require('core-js/modules/es6.reflect.is-extensible');

require('core-js/modules/es6.reflect.own-keys');

require('core-js/modules/es6.reflect.prevent-extensions');

require('core-js/modules/es6.reflect.set');

require('core-js/modules/es6.reflect.set-prototype-of');

require('core-js/modules/es6.promise');

require('core-js/modules/es6.symbol');

require('core-js/modules/es6.object.freeze');

require('core-js/modules/es6.object.seal');

require('core-js/modules/es6.object.prevent-extensions');

require('core-js/modules/es6.object.is-frozen');

require('core-js/modules/es6.object.is-sealed');

require('core-js/modules/es6.object.is-extensible');

require('core-js/modules/es6.object.get-own-property-descriptor');

require('core-js/modules/es6.object.get-prototype-of');

require('core-js/modules/es6.object.keys');

require('core-js/modules/es6.object.get-own-property-names');

require('core-js/modules/es6.object.assign');

require('core-js/modules/es6.object.is');

require('core-js/modules/es6.object.set-prototype-of');

require('core-js/modules/es6.function.name');

require('core-js/modules/es6.string.raw');

require('core-js/modules/es6.string.from-code-point');

require('core-js/modules/es6.string.code-point-at');

require('core-js/modules/es6.string.repeat');

require('core-js/modules/es6.string.starts-with');

require('core-js/modules/es6.string.ends-with');

require('core-js/modules/es6.string.includes');

require('core-js/modules/es6.regexp.flags');

require('core-js/modules/es6.regexp.match');

require('core-js/modules/es6.regexp.replace');

require('core-js/modules/es6.regexp.split');

require('core-js/modules/es6.regexp.search');

require('core-js/modules/es6.array.from');

require('core-js/modules/es6.array.of');

require('core-js/modules/es6.array.copy-within');

require('core-js/modules/es6.array.find');

require('core-js/modules/es6.array.find-index');

require('core-js/modules/es6.array.fill');

require('core-js/modules/es6.array.iterator');

require('core-js/modules/es6.number.is-finite');

require('core-js/modules/es6.number.is-integer');

require('core-js/modules/es6.number.is-safe-integer');

require('core-js/modules/es6.number.is-nan');

require('core-js/modules/es6.number.epsilon');

require('core-js/modules/es6.number.min-safe-integer');

require('core-js/modules/es6.number.max-safe-integer');

require('core-js/modules/es6.math.acosh');

require('core-js/modules/es6.math.asinh');

require('core-js/modules/es6.math.atanh');

require('core-js/modules/es6.math.cbrt');

require('core-js/modules/es6.math.clz32');

require('core-js/modules/es6.math.cosh');

require('core-js/modules/es6.math.expm1');

require('core-js/modules/es6.math.fround');

require('core-js/modules/es6.math.hypot');

require('core-js/modules/es6.math.imul');

require('core-js/modules/es6.math.log1p');

require('core-js/modules/es6.math.log10');

require('core-js/modules/es6.math.log2');

require('core-js/modules/es6.math.sign');

require('core-js/modules/es6.math.sinh');

require('core-js/modules/es6.math.tanh');

require('core-js/modules/es6.math.trunc');

require('core-js/modules/es7.array.includes');

require('core-js/modules/es7.object.values');

require('core-js/modules/es7.object.entries');

require('core-js/modules/es7.object.get-own-property-descriptors');

require('core-js/modules/es7.string.pad-start');

require('core-js/modules/es7.string.pad-end');

require('core-js/modules/web.timers');

require('core-js/modules/web.immediate');

require('core-js/modules/web.dom.iterable');

require('regenerator-runtime/runtime');

require('lazysizes/plugins/blur-up/ls.blur-up');

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('../utils/focus-ring');

require('../../styles/theme.pcss');

var _recentlyViewedProducts = require('../modules/recently-viewed-products');

var _functional = require('../utils/functional');

var _utils = require('../utils');

window.slate = window.slate || {};
window.theme = window.theme || {};

document.addEventListener('DOMContentLoaded', function () {
  (0, _utils.externalLinks)();
  (0, _utils.wrapTables)({
    elements: (0, _functional.getElements)('.rte-RichText table')
  });
  (0, _utils.wrapIframes)({
    elements: (0, _functional.getElements)('.rte-RichText iframe')
  });

  (0, _functional.getElements)('[data-module]').forEach(function (el) {
    var name = el.getAttribute('data-module');
    var Module = require('../modules/' + name).default;
    new Module(el); // eslint-disable-line no-new
  });

  // If the device is iOS add a class to the body so we can do specific CSS for it
  if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
    var _body = document.body || document.documentElement;
    _body.classList.add('is-iOS');
  }

  var recentlyViewedStorage = new _recentlyViewedProducts.RecentlyViewedStorage();
  recentlyViewedStorage.record();
});

/****
 * Setup CSS Grid & CSS Vars fallbacks
 ****/
var body = document.body || document.documentElement;
body.classList.add('util-JSEnabled');

if ('grid' in body.style === false) {
  require('../utils/css-grid-fallback');
  body.className += ' util-NoGrid';
}

function hasNativeCSSProperties() {
  var opacity = '0';
  var el = body;
  // Setup CSS properties.
  el.style.setProperty('--test-opacity', opacity);
  el.style.setProperty('opacity', 'var(--test-opacity)');
  // Feature detect then remove all set properties.
  var hasNativeCSSProperties = window.getComputedStyle(el).opacity === opacity;
  el.style.setProperty('--test-opacity', '');
  el.style.opacity = '';
  return hasNativeCSSProperties;
}

if (hasNativeCSSProperties() === false) {
  require('../utils/vars-fallback');
  body.className += ' util-NoCssVars';
}